import ServiceType from "../models/domain/ServiceType";
import { ServiceTypeResponse } from "../models/serviceApi/ServiceTypeListResponse";
export default class ServiceTypeMapper {
  static map(response: ServiceTypeResponse): ServiceType {
    return {
      name: response.name,
      type: response.type,
    };
  }

  static mapList(response: ServiceTypeResponse[]): ServiceType[] {
    return response.map(ServiceTypeMapper.map);
  }
}
